// Get the modal 1
var modal = document.getElementById("myModal");

// Get the button that opens the modal 1
var btn = document.getElementById("myBtn");

// Get the <span> element that closes the modal 1
var span = document.getElementsByClassName("close")[0];

// Get the modal 1
var modal2 = document.getElementById("myModal2");

// Get the button that opens the modal 1
var btn2 = document.getElementById("myBtn2");

// Get the <span> element that closes the modal 1
var span2 = document.getElementsByClassName("close2")[0];


// When the user clicks on the button, open the modal
btn.onclick = function() {
  modal.style.display = "block";
}

// When the user clicks on <span> (x), close the modal
span.onclick = function() {
  modal.style.display = "none";
}

// When the user clicks on the button, open the modal
btn2.onclick = function() {
  modal2.style.display = "block";
}

// When the user clicks on <span> (x), close the modal
span2.onclick = function() {
  modal2.style.display = "none";
}


// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
    
  
  if (event.target == modal) {
    if (typeof(modal) != 'undefined' && modal != null){
    modal.style.display = "none";
  }
  
  }
  else if (event.target == modal2) {
    if (typeof(modal2) != 'undefined' && modal2 != null){
    modal2.style.display = "none";
  }
  
  }
    
}

  
